import React from "react";
import { ui } from "../ui";

export default function Privacidade() {
  return (
    <div style={ui.page}>
      <div style={ui.container}>
        <header style={ui.top}>
          <a href="/" style={ui.brand}>
            <img
              src={`${process.env.PUBLIC_URL}/logo.png`}
              alt="CarMatcher"
              style={ui.logo}
            />
            <div style={ui.brandText}>
              <div style={ui.brandName}>CarMatcher</div>
              <div style={ui.brandTag}>Política de Privacidade</div>
            </div>
          </a>

          <a href="/" style={ui.buttonSecondary}>
            Voltar
          </a>
        </header>

        <article style={ui.card}>
          <h1 style={{ ...ui.h1, fontSize: 28 }}>
            Política de Privacidade do CarMatcher
          </h1>
          <p style={ui.small}>Última atualização: 27/01/2026</p>

          <div style={ui.hr} />

          <p style={ui.policy.p}>
            Esta Política de Privacidade descreve como o CarMatcher coleta,
            utiliza, compartilha e protege dados pessoais quando você usa o
            aplicativo CarMatcher e os sites relacionados. Ao criar uma conta ou
            utilizar o CarMatcher, você declara que leu e compreendeu esta
            política.
          </p>

          <h2 style={ui.policy.h2}>1. Quem somos e como falar conosco</h2>
          <p style={ui.policy.p}>
            O CarMatcher é um aplicativo voltado à descoberta, avaliação e
            negociação de veículos, conectando pessoas interessadas em comprar,
            vender ou trocar veículos por meio de interações no estilo swipe e
            recursos de match.
          </p>
          <p style={ui.policy.p}>Controlador dos dados pessoais: CarMatcher.</p>
          <p style={ui.policy.p}>
            Email de contato para privacidade: privacidade@carmatcher.com.br.
          </p>
          <p style={ui.policy.p}>
            Email de suporte: suporte@carmatcher.com.br.
          </p>
          <p style={ui.policy.p}>Site: carmatcher.com.br.</p>

          <h2 style={ui.policy.h2}>2. Dados pessoais que coletamos</h2>
          <p style={ui.policy.p}>
            Os dados coletados variam conforme as funcionalidades usadas e as
            permissões concedidas no seu dispositivo.
          </p>

          <h3 style={ui.policy.h3}>2.1. Dados fornecidos por você</h3>
          <ul style={ui.policy.ul}>
            <li>
              Dados de cadastro e conta: nome, email, telefone, senha ou
              credenciais de login, quando aplicável.
            </li>
            <li>
              Dados de perfil: foto de perfil e informações que você decidir
              incluir, como cidade e preferências.
            </li>
            <li>
              Dados de veículos e anúncios: marca, modelo, ano, versão,
              quilometragem, preço, descrição, opcionais e fotos do veículo.
            </li>
            <li>
              Conteúdos e comunicações: mensagens no chat, informações trocadas
              em negociações, solicitações de suporte e feedbacks enviados.
            </li>
            <li>
              Avaliações e denúncias: avaliações pós negociação, relatos e
              informações enviadas ao usar recursos de denúncia e bloqueio.
            </li>
          </ul>

          <h3 style={ui.policy.h3}>2.2. Dados coletados automaticamente</h3>
          <ul style={ui.policy.ul}>
            <li>
              Dados de uso: interações no app, como curtidas, descartes,
              matches, cliques, navegação em telas e eventos de sessão.
            </li>
            <li>
              Dados técnicos do dispositivo: modelo, sistema operacional,
              idioma, fuso, identificadores do aplicativo, endereço IP e dados
              de rede.
            </li>
            <li>
              Logs de segurança e diagnóstico: registros de falhas, métricas de
              desempenho e sinais para prevenção de fraudes e abusos.
            </li>
          </ul>

          <h3 style={ui.policy.h3}>2.3. Dados de pagamentos e créditos</h3>
          <p style={ui.policy.p}>
            O CarMatcher pode oferecer recursos pagos, como a liberação de chat
            após match e recargas de créditos. Para isso, podemos registrar
            informações relacionadas à compra, como valor, data, status e
            identificadores da transação. Os dados completos do meio de
            pagamento, como número do cartão, são tratados pelo provedor de
            pagamento e, em regra, não são armazenados pelo CarMatcher.
          </p>

          <h3 style={ui.policy.h3}>2.4. Fotos e arquivos de mídia</h3>
          <p style={ui.policy.p}>
            Ao enviar fotos do veículo ou imagens no chat, esses arquivos são
            armazenados em serviços de infraestrutura do CarMatcher. As fotos do
            anúncio podem ser exibidas a outros usuários. Imagens trocadas no
            chat podem ser visíveis apenas às pessoas envolvidas naquela
            conversa, conforme a funcionalidade do app.
          </p>

          <h3 style={ui.policy.h3}>2.5. Notificações</h3>
          <p style={ui.policy.p}>
            Se você permitir, o CarMatcher pode enviar notificações para
            informar sobre matches, mensagens, andamento de negociações,
            atualizações do aplicativo e informações sobre créditos. Você pode
            desativar notificações a qualquer momento nas configurações do seu
            dispositivo.
          </p>

          <h3 style={ui.policy.h3}>2.6. O que não coletamos no momento</h3>
          <p style={ui.policy.p}>
            No momento, o CarMatcher não coleta sua localização. Se no futuro a
            localização passar a ser utilizada, o app solicitará permissão e
            esta política será atualizada.
          </p>

          <h2 style={ui.policy.h2}>3. Para que usamos os dados</h2>
          <ul style={ui.policy.ul}>
            <li>Criar e gerenciar sua conta e autenticar acessos.</li>
            <li>
              Permitir cadastro, edição e exibição de veículos e anúncios.
            </li>
            <li>
              Operar as funcionalidades de swipe, match, lista de favoritos e
              histórico de interações.
            </li>
            <li>
              Habilitar o chat e recursos de negociação, quando aplicável,
              mediante créditos ou pagamento.
            </li>
            <li>
              Processar compras, recargas de créditos, conciliações e prevenção
              de fraudes em transações.
            </li>
            <li>
              Enviar comunicações essenciais e notificações relacionadas ao
              serviço.
            </li>
            <li>
              Realizar suporte, responder solicitações e resolver problemas.
            </li>
            <li>
              Melhorar desempenho, usabilidade e segurança do aplicativo,
              incluindo monitoramento de erros e prevenção de abusos.
            </li>
          </ul>

          <h2 style={ui.policy.h2}>4. Bases legais para o tratamento</h2>
          <p style={ui.policy.p}>
            O CarMatcher trata dados pessoais com base em uma ou mais bases
            legais previstas na Lei Geral de Proteção de Dados, incluindo
            execução de contrato, consentimento quando aplicável, legítimo
            interesse, cumprimento de obrigação legal e exercício regular de
            direitos.
          </p>

          <h2 style={ui.policy.h2}>5. Com quem compartilhamos os dados</h2>
          <p style={ui.policy.p}>
            O CarMatcher pode compartilhar dados pessoais nas seguintes
            hipóteses:
          </p>
          <ul style={ui.policy.ul}>
            <li>
              Com outros usuários: informações do seu anúncio e do seu perfil
              podem ser exibidas conforme a lógica do app, para viabilizar o
              match e a negociação.
            </li>
            <li>
              Com provedores de infraestrutura e tecnologia: serviços de
              hospedagem, banco de dados, armazenamento de mídias, envio de
              notificações, analytics e atendimento, somente para operar e
              melhorar o serviço.
            </li>
            <li>
              Com provedores de pagamento: para processar transações, conciliar
              pagamentos e prevenir fraudes relacionadas às compras e aos
              créditos.
            </li>
            <li>
              Com autoridades e terceiros por obrigação legal: quando necessário
              para cumprir lei, ordem judicial ou solicitações válidas de
              autoridades competentes.
            </li>
            <li>
              Em reorganizações societárias: em caso de fusão, aquisição ou
              reorganização, com medidas de proteção adequadas.
            </li>
          </ul>
          <p style={ui.policy.p}>O CarMatcher não vende dados pessoais.</p>

          <h2 style={ui.policy.h2}>6. Transferências internacionais</h2>
          <p style={ui.policy.p}>
            Podemos utilizar fornecedores de tecnologia que armazenam ou
            processam dados em servidores localizados fora do Brasil. Nesses
            casos, adotamos medidas para que o tratamento observe a legislação
            aplicável e padrões razoáveis de segurança.
          </p>

          <h2 style={ui.policy.h2}>7. Retenção e exclusão</h2>
          <p style={ui.policy.p}>
            Mantemos dados pessoais pelo tempo necessário para cumprir as
            finalidades descritas nesta política, para cumprir obrigações legais
            e regulatórias, e para resguardar direitos em eventuais disputas. Ao
            solicitar a exclusão da conta, alguns dados podem ser retidos quando
            a lei permitir ou exigir, por exemplo, para fins de auditoria,
            prevenção de fraudes e cumprimento de obrigações.
          </p>

          <h2 style={ui.policy.h2}>8. Segurança</h2>
          <p style={ui.policy.p}>
            Adotamos medidas técnicas e organizacionais para proteger dados
            pessoais contra acesso não autorizado, perda, alteração, divulgação
            indevida ou destruição. Ainda assim, nenhum ambiente é totalmente
            livre de riscos. Por isso, recomendamos que você proteja suas
            credenciais e evite compartilhar senha com terceiros.
          </p>

          <h2 style={ui.policy.h2}>9. Seus direitos</h2>
          <p style={ui.policy.p}>
            Você pode exercer os direitos previstos na legislação, incluindo:
          </p>
          <ul style={ui.policy.ul}>
            <li>Confirmação da existência de tratamento e acesso aos dados.</li>
            <li>Correção de dados incompletos, inexatos ou desatualizados.</li>
            <li>
              Anonimização, bloqueio ou eliminação de dados desnecessários,
              excessivos ou tratados em desconformidade, quando aplicável.
            </li>
            <li>Portabilidade, quando aplicável.</li>
            <li>Informações sobre compartilhamento com terceiros.</li>
            <li>Revogação de consentimento, quando aplicável.</li>
            <li>
              Solicitação de exclusão da conta, observadas retenções legais.
            </li>
          </ul>
          <p style={ui.policy.p}>
            Para solicitações, envie um email para privacidade@carmatcher.com.br
            com o assunto Privacidade e LGPD, e descreva seu pedido. Podemos
            solicitar informações adicionais para confirmar sua identidade.
          </p>

          <h2 style={ui.policy.h2}>10. Crianças e adolescentes</h2>
          <p style={ui.policy.p}>
            O CarMatcher não é destinado a menores de 18 anos. Se você acredita
            que um menor forneceu dados pessoais, entre em contato para que
            possamos avaliar e tomar providências.
          </p>

          <h2 style={ui.policy.h2}>11. Cookies e tecnologias no site</h2>
          <p style={ui.policy.p}>
            Se você acessar nossos sites, poderemos usar cookies e tecnologias
            similares para funções básicas, segurança e métricas de acesso. Você
            pode gerenciar cookies no seu navegador, lembrando que isso pode
            afetar algumas funções.
          </p>

          <h2 style={ui.policy.h2}>12. Alterações desta política</h2>
          <p style={ui.policy.p}>
            Podemos atualizar esta Política de Privacidade periodicamente. A
            versão vigente ficará disponível em nosso site. Quando mudanças
            relevantes ocorrerem, poderemos informar no aplicativo ou por email.
          </p>

          <h2 style={ui.policy.h2}>13. Contato</h2>
          <p style={ui.policy.p}>
            Dúvidas, solicitações e reclamações sobre privacidade podem ser
            enviadas para: privacidade@carmatcher.com.br.
          </p>

          <div style={ui.footer}>privacidade@carmatcher.com.br</div>
        </article>
      </div>
    </div>
  );
}
